import { Form } from "@fpsoftware/mvp";
import type { ComponentProps } from "react";
import { type Control, type FieldPath, useController } from "react-hook-form";
import type { FieldValues } from "react-hook-form/dist/types/fields";
import { FormGroup } from "@/components/form/FormGroup";

interface SelectFieldProps<TFieldValues extends FieldValues>
  extends Omit<ComponentProps<typeof Form.Select>, "id" | "name"> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  required?: boolean;
}

export function SelectField<TFieldValues extends FieldValues>(
  props: SelectFieldProps<TFieldValues>,
) {
  const { control, name, label, required, ...rest } = props;
  const { field, fieldState } = useController({ control, name });

  return (
    <FormGroup
      label={label}
      htmlFor={name}
      error={fieldState.error?.message}
      required={required}
    >
      <Form.Select id={name} error={!!fieldState.error} {...field} {...rest} />
    </FormGroup>
  );
}
